import React from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { RootState } from "../services/rootReducer";
import { Dropdown, Button } from 'react-bootstrap';
//import ReactTooltip from "react-tooltip";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ReactTooltip from "react-tooltip";
import { setSortField, setSortOrder, sortFieldType, reverseSortFieldType, sortType, selectSortConfig } from "../services/View_Slice";
import styles from "./css/SortControl.module.css";
import CONSTANTS from "../constants";
import logger from '../loggers/logger';



const SortControl: any = ((props: any) =>{
    const dispatch = useDispatch();
    const { listSortedFeld, listSortedOrder } = useSelector(selectSortConfig);
    const mobile = useSelector((state: RootState) => state.View.mobile);

    //
    const usedLabelStyle = mobile ? styles.label_mobile: styles.label;
    const usedGlIconStyle = mobile ? styles.glIcon_mobile: styles.glIcon;
    const usedGlButton = mobile ? styles.glButton_mobile : styles.glButton; //manca mobile
    const usedGlDropdown = mobile ? styles.glDropdown_mobile: styles.glDropdown;

    const dropDownItemsToRender = Object.keys(CONSTANTS.UI.SORTING_FIELDS).map(item => {
        return(
            <Dropdown.Item key={item} eventKey={item} className={usedLabelStyle}>{item}</Dropdown.Item>
        )
    });

    const anIcon = listSortedOrder===sortType.descending ? <ArrowDownwardIcon className={usedGlIconStyle}/> : <ArrowUpwardIcon className={usedGlIconStyle}/>;
    const alternateSortOrder = listSortedOrder===sortType.descending ? sortType.ascending : sortType.descending;

    return(
        <div className={styles.container}>
            <div className={usedLabelStyle}>Sort by</div> 
            <Dropdown
                className={usedGlDropdown}
                onSelect={(e) => {
                    //logger.info("@@@@@@@@@ SortControl onSelect:" + e);
                    switch(e){
                        case reverseSortFieldType.file_modified_dt:
                            dispatch(setSortField(sortFieldType.date));
                            break;
                        case reverseSortFieldType.path_basename_s:
                            dispatch(setSortField(sortFieldType.filename));
                            break;
                        default:
                            //logger.info("@@@@@@@@@ SortControl onSelect: NOTHING DONE");
                            break
                    }
                }}
                >
                <Dropdown.Toggle variant="outline" id="dropdown-basic"
                    size="sm"
                    data-for="tipSortSwitch"
                    data-tip>
                    {reverseSortFieldType[listSortedFeld]}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {dropDownItemsToRender}
                </Dropdown.Menu>

                <Button variant="outline-secondary" size="sm"
                            value={listSortedOrder}
                            className={usedGlButton}
                            data-for="tipSortAD"
                            data-tip
                            onClick={(e) => {
                                dispatch(setSortOrder(alternateSortOrder));
                            }}
                            >
                            {anIcon}
                    </Button>
            </Dropdown>
            <ReactTooltip className={styles.glToolTip} id="tipSortAD" place="top" effect="solid" textColor='#000000'backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR}>
                        Ascending/Descending
                    </ReactTooltip>
            <ReactTooltip className={styles.glToolTip} id="tipSortSwitch" place="top" effect="solid" textColor='#000000'backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR}>
                Sort by date/name
            </ReactTooltip>
        </div>
    )

});

export default React.memo(SortControl);
